import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import FreeLanding from "./pages/FreeLanding";
import AgencyLogin from "./pages/AgencyLogin";
import AgencyRegister from "./pages/AgencyRegister";
import ClientLogin from "./pages/ClientLogin";
import ClientRegister from "./pages/ClientRegister";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import NoteLegali from "./pages/NoteLegali";
import ComeFunzionaLai from "./pages/ComeFunzionaLai";
import UploadLink from "./pages/UploadLink";

import DashboardLayout from "./components/DashboardLayout";
import DashboardHome from "./pages/DashboardHome";
import DashboardSettings from "./pages/DashboardSettings";
import AdminApprovals from "./pages/AdminApprovals";
import AdminUsers from "./pages/AdminUsers";
import AdminStoryDiagnostics from "./pages/AdminStoryDiagnostics";
import AdminSecurity from "./pages/AdminSecurity";
import AdminDpa from "./pages/AdminDpa";
import ClientDpaAgreement from "./pages/ClientDpaAgreement";
import StaffClients from "./pages/StaffClients";
import StaffMessages from "./pages/StaffMessages";
import ClientDetail from "./pages/ClientDetail";
import ClientChat from "./pages/ClientChat";
import ProductionDashboard from "./pages/ProductionDashboard";
import PostpickrQueue from "./pages/PostpickrQueue";
import CodaMetricoolFoto from "./pages/CodaMetricoolFoto";
import Rubrica from "./pages/Rubrica";
import RubricaFoto from "./pages/RubricaFoto";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          richColors
          position="top-right"
          toastOptions={{ style: { fontFamily: "Satoshi, system-ui, sans-serif" } }}
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gratis" element={<FreeLanding />} />
          <Route path="/agenzia/login" element={<AgencyLogin />} />
          <Route path="/agenzia/registrati" element={<AgencyRegister />} />
          <Route path="/cliente/login" element={<ClientLogin />} />
          <Route path="/cliente/registrati" element={<ClientRegister />} />
          <Route path="/password-dimenticata" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verifica-email" element={<VerifyEmail />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/note-legali" element={<NoteLegali />} />
          <Route path="/come-funziona-lai" element={<ComeFunzionaLai />} />
          <Route path="/upload/:token" element={<UploadLink />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardHome />} />
            <Route path="impostazioni" element={<DashboardSettings />} />
            <Route path="accordo" element={<ClientDpaAgreement />} />
            <Route
              path="accordi"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AdminDpa />
                </ProtectedRoute>
              }
            />
            <Route
              path="clienti"
              element={
                <ProtectedRoute roles={["admin", "agency"]}>
                  <StaffClients />
                </ProtectedRoute>
              }
            />
            <Route
              path="clienti/:id"
              element={
                <ProtectedRoute roles={["admin", "agency"]}>
                  <ClientDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="messaggi"
              element={
                <ProtectedRoute roles={["admin", "agency"]}>
                  <StaffMessages />
                </ProtectedRoute>
              }
            />
            <Route
              path="produzione"
              element={
                <ProtectedRoute roles={["admin", "agency"]}>
                  <ProductionDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="coda-metricool"
              element={
                <ProtectedRoute roles={["admin", "agency"]}>
                  <PostpickrQueue />
                </ProtectedRoute>
              }
            />
            <Route
              path="coda-metricool-foto"
              element={
                <ProtectedRoute roles={["admin", "agency"]}>
                  <CodaMetricoolFoto />
                </ProtectedRoute>
              }
            />
            <Route
              path="coda-postpickr"
              element={
                <ProtectedRoute roles={["admin", "agency"]}>
                  <PostpickrQueue />
                </ProtectedRoute>
              }
            />
            <Route
              path="rubrica"
              element={
                <ProtectedRoute roles={["admin", "agency"]}>
                  <Rubrica />
                </ProtectedRoute>
              }
            />
            <Route
              path="rubrica-foto"
              element={
                <ProtectedRoute roles={["admin", "agency"]}>
                  <RubricaFoto />
                </ProtectedRoute>
              }
            />
            <Route
              path="chat"
              element={
                <ProtectedRoute roles={["client"]}>
                  <ClientChat />
                </ProtectedRoute>
              }
            />
            <Route
              path="approvazioni"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AdminApprovals />
                </ProtectedRoute>
              }
            />
            <Route
              path="utenti"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AdminUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="diagnostica-idee"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AdminStoryDiagnostics />
                </ProtectedRoute>
              }
            />
            <Route
              path="sicurezza"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AdminSecurity />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
